<template>
<div   style="background:#eceaea;">

<div class="container">
  
  <div class='has-info'  id="toPay">
        <div   class='info-item'   >  
                    
			本次支付：<span id="amount" style="color:red;margin-right: 10px">{{amount}}</span> 
	      <span id="name"  >{{sk_name}}</span> 
        </div>          
		<div  id="qrcode"  class='info-item'   >
                
            </div>
			<div class="info-item">
                                                 
									<span style="text-align:center;font-size:12px;color:#909399" ></span>手机微信扫一扫<span></span>
                                    
               </div>
		 
	</div>
	
	  <div class='has-info'  id="afterPay" style="display:none">
	  <el-result icon="success" title="支付成功" subTitle="感谢您的支持!">
      <template slot="extra">
	    <el-button type="primary" size="medium" @click="toOrder()" >我的订单</el-button>
        <el-button type="success" size="medium" @click="goBack()" >返回首页</el-button>
      </template>
      </el-result>
         		 
		 
	</div>
</div>
</div>		 
</template>
<style>
 
.container {
    display: flex;
	flex-direction: column;
    align-items: center;
    overflow-x: hidden;
}
.header{
  height: 80px;
  width: 100%;
  background: #fff;
}
.logo{
    display: flex;
    justify-content: flex-start;
	position: absolute;
	left: 20px;
	top: 20px;
}

.has-info {
    display: flex;
    flex-direction: column;
	margin-top:30px;
    padding: 50px;
	background: #fff;
	width: 500px;
	height: 500px;
	border-radius: 10px;
    align-items: center; 
    margin-bottom: 10px;
    position: relative;
}

.has-info .info-item {
    padding: 30rpx 0;
    display: flex;
    justify-content: center;  
    background: #fff;
   /* border-radius: 10px;
    box-shadow: 2px 2px 2px #f1f1f1; */
    margin-bottom: 20px;
    position: relative; 
	width: 100%;
}

.has-info .info-item .edit-wrap{
    padding: 30rpx;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<script>


  export default {
        name: "payment",
        data () {
		  return{
	    	activeIndex: '1',
		    userInfo: {},
			customShow : true,
			erpShow: false,
			amount: 0, 
			order_id: 0,
			sk_id: 0,
			sk_name: '',
            seconds: 0,			
			timer: null,
			} 
        },
        methods: { 
		    goBack(){
			  this.$router.push({path: '/home/index'});
			
			},
		    toOrder(){
			  this.$router.push({name: 'order'});
			
			},
		  // 查询订单状态
			queryPayStatus() {
			  let that = this; 
			  let orderId = localStorage.getItem('orderId');
			  $.ajax({
						 type: "get",
						 url: 'https://www.myferp.com/admin/user/checkPayStatus',
						 data: {orderId, orderId}, 
						 dataType: "text",
						 beforeSend: function (request) {
							request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
							},  
						 error: function(XMLHttpRequest, textStatus, errorThrown) {
									alert('请求失败!');
								},
						 success: function(res){
									 console.log(res); 
									 that.seconds = that.seconds + 3;
									 if (that.seconds > 300)
									     clearInterval(that.timer); 
									 let info = JSON.parse(res);
								     if (info.errno == 0){
								       
								         clearInterval(that.timer);
                                         $("#toPay").css("display","none");
									     $("#afterPay").css("display","flex");
									   }									  
									 
								  }
					 });
		 
			
				 
			}

		},
		created(){

		},
		mounted() {
		  var amount = 0;
  
          amount =  localStorage.getItem('orderAmount'); 
          this.amount = amount;
          var orderName =  localStorage.getItem('orderName'); 
          this.sk_name = orderName; 
		
		
		  var data = localStorage.getItem('wxPay');
		  var qr = JSON.parse(data);
		  console.log(qr.data.code_url);
		  $("#qrcode").empty();
		  $('#qrcode').qrcode(qr.data.code_url);
		  
			// 启动定时器
			this.timer = setInterval(() => {
			  this.queryPayStatus()
			}, 3000)
		},
        beforeDestroy(){
		 // clearInterval(this.timer);
		
		},
		} 
</script>

 
 


// WEBPACK FOOTER //
// src/components/customs/wxPay.vue